import { BeeTextInput, Typography, useTheme } from '@sky-distribution/react-commons-ui';
import * as React from 'react';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { TranslationRecord } from '../../translations/TranslationRecord';
import { Tenant, TENANT_NAME } from '../../config/tenants';
import styled from 'styled-components';

interface PhoneNumberInputProps {
  setFieldValue: (name: string, value: string | undefined) => void;
  error?: string;
  initialValue?: string;
}

const TuwPhoneInputWrapper = styled.div`
  > div {
    padding-top: 0 !important;
  }

  > div > div:first-child:focus-within {
    border-color: ${({ theme }) => theme?.palette?.input?.border?.selected ?? '#4545FF'} !important;
    border-style: solid !important;
    border-width: 0.125rem !important;
  }

  > div > div:first-child:focus-within::before {
    content: none !important;
    background: none !important;
  }

  > div > div:last-child {
    padding-left: 0 !important;
  }
`;

export const PhoneNumberInput = ({ setFieldValue, error, initialValue }: PhoneNumberInputProps): JSX.Element => {
  const { t } = useTypedTranslate();
  const theme = useTheme();
  const isTuw = TENANT_NAME === Tenant.TUW;
  const tuwPhonePattern = /^\+\d{2}\s\d{3}[ -]?\d{3}[ -]?\d{3}$/;
  const input = (
    <BeeTextInput
      data-testid="phone-number-input"
      name="phoneNumber"
      label={isTuw ? undefined : t('PHONE_NUMBER')}
      error={t(error?.toUpperCase() as keyof TranslationRecord)}
      type="tel"
      helperText={t('PHONE_NUMBER_HELPER_TEXT')}
      placeholder={isTuw ? '+ 48 123 456 789' : undefined}
      maskProps={{
        mask: isTuw ? '+48 999 999 999' : '+48 999-999-999',
        alwaysShowMask: false,
        maskChar: '',
      }}
      value={initialValue}
      validatorProps={{
        validate: {
          isValidPhoneNumber: true,
        },
        validators: isTuw
          ? {
              isValidPhoneNumber: (value: string) => tuwPhonePattern.test(value),
            }
          : undefined,
        errorMessages: isTuw
          ? {
              isValidPhoneNumber: 'Powinien być w formacie 48 000 000 000',
            }
          : undefined,
        onCorrectChange: (value) => setFieldValue('phoneNumber', value.slice(3)),
        onIncorrectChange: () => setFieldValue('phoneNumber', undefined),
        normalize: true,
      }}
      tabIndex={13}
    />
  );

  return (
    <>
      {isTuw && (
        <Typography variant="h4" color={theme.palette.text.header}>
          {t('PHONE_NUMBER')}
        </Typography>
      )}
      {isTuw ? <TuwPhoneInputWrapper>{input}</TuwPhoneInputWrapper> : input}
    </>
  );
};
